module.exports = __webpack_public_path__ + "static/img/3.dbb694a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/internationalBrand/hnweR22/3.jpg
// module id = 354N
// module chunks = 1